<!-- ══════ Validate User ══════ -->
<div *ngIf="email" style="padding: 24px 16px; max-width: 900px; margin: 0 auto;">
  <div style="background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); border: 1px solid #e5e7eb; overflow: hidden;">

    <!-- ── Header gradiente ── -->
    <div style="background: linear-gradient(135deg, #1e5a3f 0%, #059669 100%); padding: 24px 28px; text-align: center;">
      <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
        <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #a7f3d0;">verified_user</mat-icon>
        <h1 *ngIf="!isCompany" style="margin: 0; font-size: 1.35rem; font-weight: 800; color: white; letter-spacing: 0.3px;">
          Datos personales
        </h1>
        <h1 *ngIf="isCompany" style="margin: 0; font-size: 1.35rem; font-weight: 800; color: white; letter-spacing: 0.3px;">
          Datos Empresa
        </h1>
      </div>
      <p style="margin: 6px 0 0; font-size: 0.82rem; color: #a7f3d0; font-weight: 400;">
        Completa tu información para verificar tu identidad
      </p>
    </div>

    <!-- ── Body ── -->
    <div style="padding: 28px 24px;">

      <!-- ════════════════════════════════ -->
      <!-- FORMULARIO PERSONA NATURAL      -->
      <!-- ════════════════════════════════ -->
      <form [formGroup]="datosForm" *ngIf="!isCompany">

        <!-- ── Sección: Identificación ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">badge</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Identificación</span>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="nombre"
              placeholder="Ingresa tu nombre" />
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Apellidos</mat-label>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="apellido"
              placeholder="Ingresa tu apellido" />
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Tipo documento</mat-label>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">
                {{ tipoID }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Numero identificación</mat-label>
            <input (blur)="validateRut()" type="text" matInput formControlName="numeroId"
              placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['numeroId'].invalid &&
                (this.datosForm.controls['numeroId'].dirty || this.datosForm.controls['numeroId'].touched)"
              class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('numeroId')!.errors!['incorrectFormat'] === true">
                Ingrese un rut válido
              </mat-error>
              <mat-error *ngIf="this.datosForm.get('numeroId')!.hasError('maxlength')">
                Máximo 15 caracteres
              </mat-error>
            </div>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-y-1" style="margin-top: 4px;">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Nacionalidad</mat-label>
            <input type="text" placeholder="Selecciona un país" matInput formControlName="nacionalidad"
              required [matAutocomplete]="autoPaisNacionalidad" (blur)="checkPais('nacionalidad')" />
            <mat-autocomplete autoActiveFirstOption #autoPaisNacionalidad="matAutocomplete">
              <mat-option *ngFor="let pais of optionsNacionalidad | async" [value]="pais.NAME"
                class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

        <!-- ── Sección: Contacto ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">phone</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Contacto</span>
        </div>

        <div class="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1">
          <mat-form-field class="col-span-3 sm:col-span-1 modern-field" appearance="outline">
            <mat-label>Código</mat-label>
            <input type="text" placeholder="Selecciona uno" aria-label="Number" matInput
              formControlName="prefijoTelefono" [matAutocomplete]="auto" (blur)="checkPrefijo()" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPrefijoTelefono | async" [value]="pais.DIAL"
                class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.DIAL }} - {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field class="col-span-3 sm:col-span-2 modern-field" appearance="outline">
            <mat-label>Teléfono</mat-label>
            <input type="text" matInput appOnlynumber formControlName="telefono"
              placeholder="Ingresa tu Teléfono" />
          </mat-form-field>
        </div>

        <div class="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1">
          <mat-form-field class="col-span-3 sm:col-span-1 modern-field" appearance="outline">
            <mat-label>Sexo</mat-label>
            <mat-select required formControlName="sexo">
              <mat-option>Selecciona una opción</mat-option>
              <mat-option *ngFor="let sexo of sexos" [value]="sexo" class="flex flex-row">
                <span> {{ sexo }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-span-3 sm:col-span-2 modern-field" appearance="outline">
            <mat-label>Selecciona tu fecha</mat-label>
            <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="fechaNacimiento" />
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

        <!-- ── Sección: Residencia ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">location_on</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Residencia</span>
        </div>

        <div class="grid grid-cols-1 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>País de residencia</mat-label>
            <input type="text" placeholder="Selecciona un país" aria-label="Number" matInput
              formControlName="paisResidencia" [matAutocomplete]="autoPais"
              (blur)="checkPais('paisResidencia')" />
            <mat-autocomplete autoActiveFirstOption #autoPais="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPaisResidencia | async" [value]="pais.NAME"
                class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Ciudad de residencia</mat-label>
            <input type="text" matInput formControlName="ciudadResidencia" placeholder="Ej. Santiago" />
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Dirección</mat-label>
            <input type="text" matInput formControlName="direccion" placeholder="Ej. Santiago" />
            <mat-error *ngIf="this.datosForm.get('direccion')!.hasError('maxlength')">
              Máximo 60 caracteres
            </mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Profesión</mat-label>
            <input type="text" matInput formControlName="profesion" placeholder="Ej. Ingeniero" />
            <mat-error *ngIf="this.datosForm.get('profesion')!.hasError('maxlength')">
              Máximo 30 caracteres
            </mat-error>
          </mat-form-field>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

        <!-- ── Sección: Documentos ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">description</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Documentos</span>
        </div>

        <div style="display: flex; flex-direction: column; gap: 6px;">
          <!-- Documento Frontal -->
          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen frontal del documento</span>
            </div>
            <mat-form-field class="w-full modern-field" appearance="outline">
              <ngx-mat-file-input class="w-full" formControlName="documentoFrontal"
                [multiple]="false" [accept]="'image/*'" color="primary"
                placeholder="Adjunte imagen frontal de su documento">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid &&
                  (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </mat-form-field>
          </div>

          <!-- Documento Posterior -->
          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen posterior del documento</span>
            </div>
            <mat-form-field appearance="outline" class="w-full modern-field">
              <ngx-mat-file-input [multiple]="false" formControlName="documentoPosterior"
                [accept]="'image/*'" color="primary"
                placeholder="Adjunte imagen posterior de su documento">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid &&
                  (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </mat-form-field>
          </div>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 20px 0;"></div>

        <!-- ── PEP Toggle ── -->
        <div style="display: flex; align-items: center; gap: 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">security</mat-icon>
          <mat-slide-toggle formControlName="politicamenteExpuesto"
            style="font-size: 0.88rem; color: #374151; font-weight: 500;">
            ¿Es usted una persona expuesta politicamente?
          </mat-slide-toggle>
        </div>

        <!-- ── Botón Enviar ── -->
        <div style="display: flex; justify-content: center; margin-top: 28px;">
          <button type="button" (click)="enviarDatos()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 48px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease; letter-spacing: 0.3px;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
            Enviar datos
          </button>
        </div>
      </form>

      <!-- ════════════════════════════════ -->
      <!-- FORMULARIO EMPRESA              -->
      <!-- ════════════════════════════════ -->
      <form [formGroup]="datosForm" *ngIf="isCompany">

        <!-- ── Sección: Representante Legal ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">person</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Representante Legal</span>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="nombre"
              placeholder="Ingresa tu nombre" />
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Apellidos</mat-label>
            <input type="text" pattern="[ a-zA-Z]*" matInput formControlName="apellido"
              placeholder="Ingresa tu apellido" />
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('apellido')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Tipo documento</mat-label>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">
                {{ tipoID }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Numero identificación</mat-label>
            <input (blur)="validateRut()" type="text" matInput formControlName="numeroId"
              placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['numeroId'].invalid &&
                (this.datosForm.controls['numeroId'].dirty || this.datosForm.controls['numeroId'].touched)"
              class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('numeroId')!.errors!['incorrectFormat'] === true">
                Ingrese un rut válido
              </mat-error>
              <mat-error *ngIf="this.datosForm.get('numeroId')!.hasError('maxlength')">
                Máximo 15 caracteres
              </mat-error>
            </div>
          </mat-form-field>
        </div>

        <!-- Teléfono -->
        <div class="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1" style="margin-top: 4px;">
          <mat-form-field class="col-span-3 sm:col-span-1 modern-field" appearance="outline">
            <mat-label>Código</mat-label>
            <input type="text" placeholder="Selecciona uno" aria-label="Number" matInput
              formControlName="prefijoTelefono" [matAutocomplete]="auto" (blur)="checkPrefijo()" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPrefijoTelefono | async" [value]="pais.DIAL"
                class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.DIAL }} - {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field class="col-span-3 sm:col-span-2 modern-field" appearance="outline">
            <mat-label>Teléfono</mat-label>
            <input type="text" matInput appOnlynumber formControlName="telefono"
              placeholder="Ingresa tu Teléfono" />
          </mat-form-field>
        </div>

        <!-- Documentos Representante -->
        <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 12px;">
          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen frontal del documento</span>
            </div>
            <mat-form-field class="w-full modern-field" appearance="outline">
              <ngx-mat-file-input class="w-full" formControlName="documentoFrontal"
                [multiple]="false" [accept]="'image/*'" color="primary"
                placeholder="Adjunte imagen frontal de su documento">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid &&
                  (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </mat-form-field>
          </div>

          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen posterior del documento</span>
            </div>
            <mat-form-field appearance="outline" class="w-full modern-field">
              <ngx-mat-file-input [multiple]="false" formControlName="documentoPosterior"
                [accept]="'image/*'" color="primary"
                placeholder="Adjunte imagen posterior de su documento">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid &&
                  (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </mat-form-field>
          </div>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 24px 0 20px;"></div>

        <!-- ── Sección: Datos de la Empresa ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">business</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Empresa</span>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Nombre o Razón Social</mat-label>
            <input type="text" matInput formControlName="razonSocial"
              placeholder="Ingresa la razón social" />
            <mat-error *ngIf="this.datosForm.get('razonSocial')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Nombre comercial</mat-label>
            <input type="text" matInput formControlName="nombreComercial"
              placeholder="Ingresa el nombre comercial" />
            <mat-error *ngIf="this.datosForm.get('nombreComercial')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Rut Empresa</mat-label>
            <input (blur)="validateRutEmpresa()" type="text" matInput formControlName="rutEmpresa"
              placeholder="Ingresa tu documento" />
            <div *ngIf="this.datosForm.controls['rutEmpresa'].invalid &&
                (this.datosForm.controls['rutEmpresa'].dirty || this.datosForm.controls['rutEmpresa'].touched)"
              class="error-file alert">
              <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.errors!['incorrectFormat'] === true">
                Ingrese un rut válido
              </mat-error>
              <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.hasError('maxlength')">
                Máximo 15 caracteres
              </mat-error>
            </div>
          </mat-form-field>

          <mat-form-field class="modern-field" appearance="outline">
            <mat-label>Domicilio fiscal</mat-label>
            <input type="text" matInput formControlName="domicilioFiscal" placeholder="Ej. Santiago" />
            <mat-error *ngIf="this.datosForm.get('domicilioFiscal')!.hasError('maxlength')">
              Máximo 60 caracteres
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Documentos Empresa -->
        <div style="display: flex; flex-direction: column; gap: 6px; margin-top: 12px;">
          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">article</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Documento de Identificación Tributario</span>
            </div>
            <mat-form-field appearance="outline" class="w-full modern-field">
              <ngx-mat-file-input [multiple]="false" formControlName="documentoIdTributario"
                [accept]="'image/*, .pdf'" color="primary"
                placeholder="Adjunte Documento de Identificación Tributario">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['documentoIdTributario'].invalid &&
                  (this.datosForm.controls['documentoIdTributario'].dirty || this.datosForm.controls['documentoIdTributario'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoIdTributario')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('documentoIdTributario')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG, PNG o PDF
                </mat-error>
              </div>
            </mat-form-field>
          </div>

          <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">gavel</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Estatuto constitutivo de la empresa</span>
            </div>
            <mat-form-field appearance="outline" class="w-full modern-field">
              <ngx-mat-file-input [multiple]="false" formControlName="estatuto"
                [accept]="'image/*, .pdf'" color="primary"
                placeholder="Adjunte Estatuto constitutivo de la empresa">
              </ngx-mat-file-input>
              <div *ngIf="this.datosForm.controls['estatuto'].invalid &&
                  (this.datosForm.controls['estatuto'].dirty || this.datosForm.controls['estatuto'].touched)"
                class="error-file alert">
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('estatuto')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file"
                  *ngIf="this.datosForm.get('estatuto')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG, PNG o PDF
                </mat-error>
              </div>
            </mat-form-field>
          </div>
        </div>

        <!-- ── Botón Enviar ── -->
        <div style="display: flex; justify-content: center; margin-top: 28px;">
          <button type="button" (click)="enviarDatos()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 48px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease; letter-spacing: 0.3px;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
            Enviar datos
          </button>
        </div>
      </form>

    </div>
  </div>
</div>
